// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendDocumentationPopup-module__font-s-10___fj0dr {
  font-size: 10px !important;
}

.SendDocumentationPopup-module__font-s-12___E09FN {
  font-size: 12px !important;
}

.SendDocumentationPopup-module__font-s-13___Xpjlm {
  font-size: 13px !important;
}

.SendDocumentationPopup-module__font-s-14___cPmkL {
  font-size: 14px !important;
}

.SendDocumentationPopup-module__font-s-15___SgGoZ {
  font-size: 15px !important;
}

.SendDocumentationPopup-module__font-s-16___Yv7Df {
  font-size: 16px !important;
}

.SendDocumentationPopup-module__font-s-18___a_wl2 {
  font-size: 18px !important;
}

.SendDocumentationPopup-module__font-s-20___XW2ig {
  font-size: 20px !important;
}

.SendDocumentationPopup-module__font-s-22___zLQ5e {
  font-size: 22px !important;
}

.SendDocumentationPopup-module__font-s-28___ozog3 {
  font-size: 28px !important;
}

.SendDocumentationPopup-module__font-w-400___o2knu {
  font-weight: 400 !important;
}

.SendDocumentationPopup-module__font-w-500___P27a2 {
  font-weight: 500 !important;
}

.SendDocumentationPopup-module__font-w-600___zqhR3 {
  font-weight: 600 !important;
}

.SendDocumentationPopup-module__font-w-700___D4LBb {
  font-weight: 700 !important;
}

.SendDocumentationPopup-module__p-5___iDhRO {
  padding: 5px !important;
}

.SendDocumentationPopup-module__p-12___JflmK {
  padding: 12px !important;
}

.SendDocumentationPopup-module__p-16____n12J {
  padding: 16px !important;
}

.SendDocumentationPopup-module__p-30___jVl3k {
  padding: 30px !important;
}

.SendDocumentationPopup-module__p-b-0___QraJg {
  padding-bottom: 0 !important;
}

.SendDocumentationPopup-module__p-b-5___cMJ50 {
  padding-bottom: 5px !important;
}

.SendDocumentationPopup-module__p-b-10___nnPys {
  padding-bottom: 10px !important;
}

.SendDocumentationPopup-module__p-b-12___mbjTG {
  padding-bottom: 12px !important;
}

.SendDocumentationPopup-module__p-b-16___O4H3Q {
  padding-bottom: 16px !important;
}

.SendDocumentationPopup-module__p-b-18___chPKS {
  padding-bottom: 18px !important;
}

.SendDocumentationPopup-module__p-b-20___BDG50 {
  padding-bottom: 20px !important;
}

.SendDocumentationPopup-module__p-b-25___zmSqA {
  padding-bottom: 25px !important;
}

.SendDocumentationPopup-module__p-b-30___eguxz {
  padding-bottom: 30px !important;
}

.SendDocumentationPopup-module__p-b-50___Y4cVF {
  padding-bottom: 50px !important;
}

.SendDocumentationPopup-module__p-t-0___V4su8 {
  padding-top: 0 !important;
}

.SendDocumentationPopup-module__p-t-12___U_0j3 {
  padding-top: 12px !important;
}

.SendDocumentationPopup-module__p-t-16___f0tND {
  padding-top: 16px !important;
}

.SendDocumentationPopup-module__p-t-18___WMkgj {
  padding-top: 18px !important;
}

.SendDocumentationPopup-module__p-t-20___VV69W {
  padding-top: 20px !important;
}

.SendDocumentationPopup-module__p-t-30___sW7oU {
  padding-top: 30px !important;
}

.SendDocumentationPopup-module__p-t-40___sNbJJ {
  padding-top: 40px !important;
}

.SendDocumentationPopup-module__p-t-50___vL7g4 {
  padding-top: 50px !important;
}

.SendDocumentationPopup-module__p-l-20___cwoTH {
  padding-left: 20px !important;
}

.SendDocumentationPopup-module__p-l-30___oP6eq {
  padding-left: 30px !important;
}

.SendDocumentationPopup-module__p-l-40___NSXdD {
  padding-left: 40px !important;
}

.SendDocumentationPopup-module__p-r-16___kIMOn {
  padding-right: 16px !important;
}

.SendDocumentationPopup-module__p-r-20___ucDfj {
  padding-right: 20px !important;
}

.SendDocumentationPopup-module__p-r-30___xG3F5 {
  padding-right: 30px !important;
}

.SendDocumentationPopup-module__p-r-50___Efo9R {
  padding-right: 50px !important;
}

.SendDocumentationPopup-module__p-r-60___YjSg9 {
  padding-right: 60px !important;
}

.SendDocumentationPopup-module__m-b-1___XPmU0 {
  margin-bottom: 1px !important;
}

.SendDocumentationPopup-module__m-b-2___UCedu {
  margin-bottom: 2px !important;
}

.SendDocumentationPopup-module__m-b-6___dLsb1 {
  margin-bottom: 6px !important;
}

.SendDocumentationPopup-module__m-b-8___MRLlt {
  margin-bottom: 8px !important;
}

.SendDocumentationPopup-module__m-b-10___JLFjF {
  margin-bottom: 10px !important;
}

.SendDocumentationPopup-module__m-b-14___esUwP {
  margin-bottom: 14px !important;
}

.SendDocumentationPopup-module__m-b-16___uKCxz {
  margin-bottom: 16px !important;
}

.SendDocumentationPopup-module__m-b-20____DYUY {
  margin-bottom: 20px !important;
}

.SendDocumentationPopup-module__m-b-22___kZo9S {
  margin-bottom: 22px !important;
}

.SendDocumentationPopup-module__m-b-24___TStpB {
  margin-bottom: 24px !important;
}

.SendDocumentationPopup-module__m-b-30___OCXDu {
  margin-bottom: 30px !important;
}

.SendDocumentationPopup-module__m-b-32___OeQeX {
  margin-bottom: 32px !important;
}

.SendDocumentationPopup-module__m-b-40___suMbH {
  margin-bottom: 40px !important;
}

.SendDocumentationPopup-module__m-t-2___iNSp2 {
  margin-top: 2px !important;
}

.SendDocumentationPopup-module__m-t-3___jnVkj {
  margin-top: 3px !important;
}

.SendDocumentationPopup-module__m-t-4___O_tQi {
  margin-top: 4px !important;
}

.SendDocumentationPopup-module__m-t-5___UYffb {
  margin-top: 5px !important;
}

.SendDocumentationPopup-module__m-t-8___JBwg4 {
  margin-top: 8px !important;
}

.SendDocumentationPopup-module__m-t-10___hY1Fk {
  margin-top: 10px !important;
}

.SendDocumentationPopup-module__m-t-15___LQ8Wi {
  margin-top: 15px !important;
}

.SendDocumentationPopup-module__m-t-16___Vi5g9 {
  margin-top: 16px !important;
}

.SendDocumentationPopup-module__m-t-20___VVeww {
  margin-top: 20px !important;
}

.SendDocumentationPopup-module__m-t-22___kKbKz {
  margin-top: 22px !important;
}

.SendDocumentationPopup-module__m-t-30___GN2U7 {
  margin-top: 30px !important;
}

.SendDocumentationPopup-module__m-t-32___UqboC {
  margin-top: 32px !important;
}

.SendDocumentationPopup-module__m-l-auto___SFCP5 {
  margin-left: auto !important;
}

.SendDocumentationPopup-module__m-l-4___qPdKm {
  margin-left: 4px !important;
}

.SendDocumentationPopup-module__m-l-5___haYxm {
  margin-left: 5px !important;
}

.SendDocumentationPopup-module__m-l-6___vXrr0 {
  margin-left: 6px !important;
}

.SendDocumentationPopup-module__m-l-8___RJ1lz {
  margin-left: 8px !important;
}

.SendDocumentationPopup-module__m-l-10___Yn9IK {
  margin-left: 10px !important;
}

.SendDocumentationPopup-module__m-l-16___tX2iP {
  margin-left: 16px !important;
}

.SendDocumentationPopup-module__m-l-20___GHJge {
  margin-left: 20px !important;
}

.SendDocumentationPopup-module__m-l-24___pX8k9 {
  margin-left: 24px !important;
}

.SendDocumentationPopup-module__m-l-30___W7nS9 {
  margin-left: 30px !important;
}

.SendDocumentationPopup-module__m-l-35___eytUC {
  margin-left: 35px !important;
}

.SendDocumentationPopup-module__m-l-40___JBDzz {
  margin-left: 40px !important;
}

.SendDocumentationPopup-module__m-r-8___cTglK {
  margin-right: 8px !important;
}

.SendDocumentationPopup-module__m-r-10___PKiGb {
  margin-right: 10px !important;
}

.SendDocumentationPopup-module__m-r-16___iNPdS {
  margin-right: 16px !important;
}

.SendDocumentationPopup-module__m-r-20___k1bXu {
  margin-right: 20px !important;
}

.SendDocumentationPopup-module__m-r-24___eM_vD {
  margin-right: 24px !important;
}

.SendDocumentationPopup-module__m-r-30___A_BsU {
  margin-right: 30px !important;
}

.SendDocumentationPopup-module__m-r-40___AsyG_ {
  margin-right: 40px !important;
}

.SendDocumentationPopup-module__border-r-3___OCbiD {
  border-radius: 3px !important;
}

.SendDocumentationPopup-module__border-r-4___WLXYd {
  border-radius: 4px !important;
}

.SendDocumentationPopup-module__border-r-6___lQ0GJ {
  border-radius: 6px !important;
}

.SendDocumentationPopup-module__border-r-10___A5OmK {
  border-radius: 10px !important;
}

.SendDocumentationPopup-module__border-r-12___WQaJ0 {
  border-radius: 12px !important;
}

.SendDocumentationPopup-module__border-r-16___xz7tu {
  border-radius: 16px !important;
}

.SendDocumentationPopup-module__border-r-50___N5rDC {
  border-radius: 50% !important;
}

.SendDocumentationPopup-module__primary-border___Qovb1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SendDocumentationPopup-module__primary-border-b___KyjRg {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SendDocumentationPopup-module__primary-border-t___s3DJo {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SendDocumentationPopup-module__primary-border-l___iCQ0A {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SendDocumentationPopup-module__primary-border-r___Q9tof {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SendDocumentationPopup-module__secondary-border___ncxo4 {
  border: 1px solid #637768;
}

.SendDocumentationPopup-module__secondary-border-b___FsKS0 {
  border-bottom: 1px solid #637768;
}

.SendDocumentationPopup-module__secondary-border-t___mJ3L6 {
  border-top: 1px solid #637768;
}

.SendDocumentationPopup-module__secondary-border-l___SVxHC {
  border-left: 1px solid #637768;
}

.SendDocumentationPopup-module__secondary-border-r___WC4OH {
  border-right: 1px solid #637768;
}

.SendDocumentationPopup-module__gap-0___hf04Q {
  gap: 0 !important;
}

.SendDocumentationPopup-module__gap-2___C8mfy {
  gap: 2px !important;
}

.SendDocumentationPopup-module__gap-4___q9ZiL {
  gap: 4px !important;
}

.SendDocumentationPopup-module__gap-5___R5eKJ {
  gap: 5px !important;
}

.SendDocumentationPopup-module__gap-6___asBTc {
  gap: 6px !important;
}

.SendDocumentationPopup-module__gap-8___cEWzU {
  gap: 8px !important;
}

.SendDocumentationPopup-module__gap-10___W9I3K {
  gap: 10px !important;
}

.SendDocumentationPopup-module__gap-12___CuEcb {
  gap: 12px !important;
}

.SendDocumentationPopup-module__gap-14___mqZpD {
  gap: 14px !important;
}

.SendDocumentationPopup-module__gap-16___GAIi0 {
  gap: 16px !important;
}

.SendDocumentationPopup-module__gap-18___I_g46 {
  gap: 18px !important;
}

.SendDocumentationPopup-module__gap-20___QC8XO {
  gap: 20px !important;
}

.SendDocumentationPopup-module__gap-24___buIPI {
  gap: 24px !important;
}

.SendDocumentationPopup-module__gap-26___comol {
  gap: 26px !important;
}

.SendDocumentationPopup-module__gap-30___uVvSA {
  gap: 30px !important;
}

.SendDocumentationPopup-module__gap-32___lZfP8 {
  gap: 32px !important;
}

.SendDocumentationPopup-module__gap-40___Z2sAh {
  gap: 40px !important;
}

.SendDocumentationPopup-module__gap-50___X8QOS {
  gap: 50px !important;
}

.SendDocumentationPopup-module__flex-1____P5J0 {
  flex: 1;
}

.SendDocumentationPopup-module__flex-none___Xvcvq {
  flex: none !important;
}

.SendDocumentationPopup-module__flex-column___ozJlZ {
  display: flex;
  flex-direction: column !important;
}

.SendDocumentationPopup-module__flex-row___AXArl {
  display: flex;
  flex-direction: row !important;
}

.SendDocumentationPopup-module__vertically-centered___se93R {
  display: flex;
  align-items: center !important;
}

.SendDocumentationPopup-module__horizontally-centered___ym_j6 {
  display: flex;
  justify-content: center !important;
}

.SendDocumentationPopup-module__horizontally-end___U5fDP {
  display: flex;
  justify-content: end !important;
}

.SendDocumentationPopup-module__vertically-start___D26pY {
  display: flex;
  align-items: start !important;
}

.SendDocumentationPopup-module__space-between___BtGGN {
  display: flex;
  justify-content: space-between !important;
}

.SendDocumentationPopup-module__flex-wrap___bqxxa {
  flex-wrap: wrap !important;
}

.SendDocumentationPopup-module__height-100___CYILY {
  height: 100%;
}

.SendDocumentationPopup-module__width-50___ZzJ9v {
  width: 50% !important;
}

.SendDocumentationPopup-module__width-100___HPRYy {
  width: 100%;
}

.SendDocumentationPopup-module__cursor-pointer___wRVks {
  cursor: pointer;
}

.SendDocumentationPopup-module__cursor-not-allowed___Lw8UE {
  cursor: not-allowed !important;
}

.SendDocumentationPopup-module__absolute-centered___zbpjT {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SendDocumentationPopup-module__absolute___UkP22 {
  position: absolute;
}

.SendDocumentationPopup-module__relative___IHJHb {
  position: relative;
}

.SendDocumentationPopup-module__fixed___Beh_T {
  position: fixed;
}

.SendDocumentationPopup-module__visible___cwIey {
  opacity: 1;
}

.SendDocumentationPopup-module__invisible___o0i2u {
  opacity: 0;
}

.SendDocumentationPopup-module__col-90___WuNkB {
  width: 90% !important;
}

.SendDocumentationPopup-module__col-auto___sfOsD {
  width: auto !important;
}

.SendDocumentationPopup-module__medical-tabs___BwmtS {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SendDocumentationPopup-module__medical-table-new___iJp8t {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t::-webkit-scrollbar-track {
  display: none;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t.SendDocumentationPopup-module__no-pagination___HlX7h {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t.SendDocumentationPopup-module__no-pagination___HlX7h:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t.SendDocumentationPopup-module__no-pagination___HlX7h::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SendDocumentationPopup-module__medical-table-new___iJp8t.SendDocumentationPopup-module__no-pagination___HlX7h::-webkit-scrollbar-track {
  display: none;
}

.SendDocumentationPopup-module__medical-table-empty___gHuF6 {
  padding: 14px 40px !important;
}

.SendDocumentationPopup-module__icon-btn___dVWgS {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SendDocumentationPopup-module__search-icon___9FeZl {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SendDocumentationPopup-module__disable-select___qe7tQ {
  user-select: none;
}

.SendDocumentationPopup-module__break-word___cIV9a {
  word-break: break-word;
}

.SendDocumentationPopup-module__popup-clear-btn___YkhYd {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SendDocumentationPopup-module__scroll-m-b-20___fOlIq {
  scroll-margin-bottom: 20px;
}

.SendDocumentationPopup-module__label___Yu6Mu {
  color: #637768;
}

.SendDocumentationPopup-module__grid___jKjZC {
  display: grid;
  row-gap: 15px;
  column-gap: 40px;
  grid-template-columns: 1fr 1fr;
}

.SendDocumentationPopup-module__error___YAoEb {
  color: #c56836;
  height: 4px;
}

.SendDocumentationPopup-module__buttonsContainer___B_zZN {
  gap: 16px;
  display: flex;
  padding: 30px;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/SendDocumentationPopup/SendDocumentationPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,WAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.label {\n  color: get-color(greenNew, medium-dark);\n}\n\n.grid {\n  display: grid;\n  row-gap: 15px;\n  column-gap: 40px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.error {\n  color: get-color(orangeNew, dark);\n  height: 4px;\n}\n\n.buttonsContainer {\n  gap: 16px;\n  display: flex;\n  padding: 30px;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SendDocumentationPopup-module__font-s-10___fj0dr`,
	"fontS12": `SendDocumentationPopup-module__font-s-12___E09FN`,
	"fontS13": `SendDocumentationPopup-module__font-s-13___Xpjlm`,
	"fontS14": `SendDocumentationPopup-module__font-s-14___cPmkL`,
	"fontS15": `SendDocumentationPopup-module__font-s-15___SgGoZ`,
	"fontS16": `SendDocumentationPopup-module__font-s-16___Yv7Df`,
	"fontS18": `SendDocumentationPopup-module__font-s-18___a_wl2`,
	"fontS20": `SendDocumentationPopup-module__font-s-20___XW2ig`,
	"fontS22": `SendDocumentationPopup-module__font-s-22___zLQ5e`,
	"fontS28": `SendDocumentationPopup-module__font-s-28___ozog3`,
	"fontW400": `SendDocumentationPopup-module__font-w-400___o2knu`,
	"fontW500": `SendDocumentationPopup-module__font-w-500___P27a2`,
	"fontW600": `SendDocumentationPopup-module__font-w-600___zqhR3`,
	"fontW700": `SendDocumentationPopup-module__font-w-700___D4LBb`,
	"p5": `SendDocumentationPopup-module__p-5___iDhRO`,
	"p12": `SendDocumentationPopup-module__p-12___JflmK`,
	"p16": `SendDocumentationPopup-module__p-16____n12J`,
	"p30": `SendDocumentationPopup-module__p-30___jVl3k`,
	"pB0": `SendDocumentationPopup-module__p-b-0___QraJg`,
	"pB5": `SendDocumentationPopup-module__p-b-5___cMJ50`,
	"pB10": `SendDocumentationPopup-module__p-b-10___nnPys`,
	"pB12": `SendDocumentationPopup-module__p-b-12___mbjTG`,
	"pB16": `SendDocumentationPopup-module__p-b-16___O4H3Q`,
	"pB18": `SendDocumentationPopup-module__p-b-18___chPKS`,
	"pB20": `SendDocumentationPopup-module__p-b-20___BDG50`,
	"pB25": `SendDocumentationPopup-module__p-b-25___zmSqA`,
	"pB30": `SendDocumentationPopup-module__p-b-30___eguxz`,
	"pB50": `SendDocumentationPopup-module__p-b-50___Y4cVF`,
	"pT0": `SendDocumentationPopup-module__p-t-0___V4su8`,
	"pT12": `SendDocumentationPopup-module__p-t-12___U_0j3`,
	"pT16": `SendDocumentationPopup-module__p-t-16___f0tND`,
	"pT18": `SendDocumentationPopup-module__p-t-18___WMkgj`,
	"pT20": `SendDocumentationPopup-module__p-t-20___VV69W`,
	"pT30": `SendDocumentationPopup-module__p-t-30___sW7oU`,
	"pT40": `SendDocumentationPopup-module__p-t-40___sNbJJ`,
	"pT50": `SendDocumentationPopup-module__p-t-50___vL7g4`,
	"pL20": `SendDocumentationPopup-module__p-l-20___cwoTH`,
	"pL30": `SendDocumentationPopup-module__p-l-30___oP6eq`,
	"pL40": `SendDocumentationPopup-module__p-l-40___NSXdD`,
	"pR16": `SendDocumentationPopup-module__p-r-16___kIMOn`,
	"pR20": `SendDocumentationPopup-module__p-r-20___ucDfj`,
	"pR30": `SendDocumentationPopup-module__p-r-30___xG3F5`,
	"pR50": `SendDocumentationPopup-module__p-r-50___Efo9R`,
	"pR60": `SendDocumentationPopup-module__p-r-60___YjSg9`,
	"mB1": `SendDocumentationPopup-module__m-b-1___XPmU0`,
	"mB2": `SendDocumentationPopup-module__m-b-2___UCedu`,
	"mB6": `SendDocumentationPopup-module__m-b-6___dLsb1`,
	"mB8": `SendDocumentationPopup-module__m-b-8___MRLlt`,
	"mB10": `SendDocumentationPopup-module__m-b-10___JLFjF`,
	"mB14": `SendDocumentationPopup-module__m-b-14___esUwP`,
	"mB16": `SendDocumentationPopup-module__m-b-16___uKCxz`,
	"mB20": `SendDocumentationPopup-module__m-b-20____DYUY`,
	"mB22": `SendDocumentationPopup-module__m-b-22___kZo9S`,
	"mB24": `SendDocumentationPopup-module__m-b-24___TStpB`,
	"mB30": `SendDocumentationPopup-module__m-b-30___OCXDu`,
	"mB32": `SendDocumentationPopup-module__m-b-32___OeQeX`,
	"mB40": `SendDocumentationPopup-module__m-b-40___suMbH`,
	"mT2": `SendDocumentationPopup-module__m-t-2___iNSp2`,
	"mT3": `SendDocumentationPopup-module__m-t-3___jnVkj`,
	"mT4": `SendDocumentationPopup-module__m-t-4___O_tQi`,
	"mT5": `SendDocumentationPopup-module__m-t-5___UYffb`,
	"mT8": `SendDocumentationPopup-module__m-t-8___JBwg4`,
	"mT10": `SendDocumentationPopup-module__m-t-10___hY1Fk`,
	"mT15": `SendDocumentationPopup-module__m-t-15___LQ8Wi`,
	"mT16": `SendDocumentationPopup-module__m-t-16___Vi5g9`,
	"mT20": `SendDocumentationPopup-module__m-t-20___VVeww`,
	"mT22": `SendDocumentationPopup-module__m-t-22___kKbKz`,
	"mT30": `SendDocumentationPopup-module__m-t-30___GN2U7`,
	"mT32": `SendDocumentationPopup-module__m-t-32___UqboC`,
	"mLAuto": `SendDocumentationPopup-module__m-l-auto___SFCP5`,
	"mL4": `SendDocumentationPopup-module__m-l-4___qPdKm`,
	"mL5": `SendDocumentationPopup-module__m-l-5___haYxm`,
	"mL6": `SendDocumentationPopup-module__m-l-6___vXrr0`,
	"mL8": `SendDocumentationPopup-module__m-l-8___RJ1lz`,
	"mL10": `SendDocumentationPopup-module__m-l-10___Yn9IK`,
	"mL16": `SendDocumentationPopup-module__m-l-16___tX2iP`,
	"mL20": `SendDocumentationPopup-module__m-l-20___GHJge`,
	"mL24": `SendDocumentationPopup-module__m-l-24___pX8k9`,
	"mL30": `SendDocumentationPopup-module__m-l-30___W7nS9`,
	"mL35": `SendDocumentationPopup-module__m-l-35___eytUC`,
	"mL40": `SendDocumentationPopup-module__m-l-40___JBDzz`,
	"mR8": `SendDocumentationPopup-module__m-r-8___cTglK`,
	"mR10": `SendDocumentationPopup-module__m-r-10___PKiGb`,
	"mR16": `SendDocumentationPopup-module__m-r-16___iNPdS`,
	"mR20": `SendDocumentationPopup-module__m-r-20___k1bXu`,
	"mR24": `SendDocumentationPopup-module__m-r-24___eM_vD`,
	"mR30": `SendDocumentationPopup-module__m-r-30___A_BsU`,
	"mR40": `SendDocumentationPopup-module__m-r-40___AsyG_`,
	"borderR3": `SendDocumentationPopup-module__border-r-3___OCbiD`,
	"borderR4": `SendDocumentationPopup-module__border-r-4___WLXYd`,
	"borderR6": `SendDocumentationPopup-module__border-r-6___lQ0GJ`,
	"borderR10": `SendDocumentationPopup-module__border-r-10___A5OmK`,
	"borderR12": `SendDocumentationPopup-module__border-r-12___WQaJ0`,
	"borderR16": `SendDocumentationPopup-module__border-r-16___xz7tu`,
	"borderR50": `SendDocumentationPopup-module__border-r-50___N5rDC`,
	"primaryBorder": `SendDocumentationPopup-module__primary-border___Qovb1`,
	"primaryBorderB": `SendDocumentationPopup-module__primary-border-b___KyjRg`,
	"primaryBorderT": `SendDocumentationPopup-module__primary-border-t___s3DJo`,
	"primaryBorderL": `SendDocumentationPopup-module__primary-border-l___iCQ0A`,
	"primaryBorderR": `SendDocumentationPopup-module__primary-border-r___Q9tof`,
	"secondaryBorder": `SendDocumentationPopup-module__secondary-border___ncxo4`,
	"secondaryBorderB": `SendDocumentationPopup-module__secondary-border-b___FsKS0`,
	"secondaryBorderT": `SendDocumentationPopup-module__secondary-border-t___mJ3L6`,
	"secondaryBorderL": `SendDocumentationPopup-module__secondary-border-l___SVxHC`,
	"secondaryBorderR": `SendDocumentationPopup-module__secondary-border-r___WC4OH`,
	"gap0": `SendDocumentationPopup-module__gap-0___hf04Q`,
	"gap2": `SendDocumentationPopup-module__gap-2___C8mfy`,
	"gap4": `SendDocumentationPopup-module__gap-4___q9ZiL`,
	"gap5": `SendDocumentationPopup-module__gap-5___R5eKJ`,
	"gap6": `SendDocumentationPopup-module__gap-6___asBTc`,
	"gap8": `SendDocumentationPopup-module__gap-8___cEWzU`,
	"gap10": `SendDocumentationPopup-module__gap-10___W9I3K`,
	"gap12": `SendDocumentationPopup-module__gap-12___CuEcb`,
	"gap14": `SendDocumentationPopup-module__gap-14___mqZpD`,
	"gap16": `SendDocumentationPopup-module__gap-16___GAIi0`,
	"gap18": `SendDocumentationPopup-module__gap-18___I_g46`,
	"gap20": `SendDocumentationPopup-module__gap-20___QC8XO`,
	"gap24": `SendDocumentationPopup-module__gap-24___buIPI`,
	"gap26": `SendDocumentationPopup-module__gap-26___comol`,
	"gap30": `SendDocumentationPopup-module__gap-30___uVvSA`,
	"gap32": `SendDocumentationPopup-module__gap-32___lZfP8`,
	"gap40": `SendDocumentationPopup-module__gap-40___Z2sAh`,
	"gap50": `SendDocumentationPopup-module__gap-50___X8QOS`,
	"flex1": `SendDocumentationPopup-module__flex-1____P5J0`,
	"flexNone": `SendDocumentationPopup-module__flex-none___Xvcvq`,
	"flexColumn": `SendDocumentationPopup-module__flex-column___ozJlZ`,
	"flexRow": `SendDocumentationPopup-module__flex-row___AXArl`,
	"verticallyCentered": `SendDocumentationPopup-module__vertically-centered___se93R`,
	"horizontallyCentered": `SendDocumentationPopup-module__horizontally-centered___ym_j6`,
	"horizontallyEnd": `SendDocumentationPopup-module__horizontally-end___U5fDP`,
	"verticallyStart": `SendDocumentationPopup-module__vertically-start___D26pY`,
	"spaceBetween": `SendDocumentationPopup-module__space-between___BtGGN`,
	"flexWrap": `SendDocumentationPopup-module__flex-wrap___bqxxa`,
	"height100": `SendDocumentationPopup-module__height-100___CYILY`,
	"width50": `SendDocumentationPopup-module__width-50___ZzJ9v`,
	"width100": `SendDocumentationPopup-module__width-100___HPRYy`,
	"cursorPointer": `SendDocumentationPopup-module__cursor-pointer___wRVks`,
	"cursorNotAllowed": `SendDocumentationPopup-module__cursor-not-allowed___Lw8UE`,
	"absoluteCentered": `SendDocumentationPopup-module__absolute-centered___zbpjT`,
	"absolute": `SendDocumentationPopup-module__absolute___UkP22`,
	"relative": `SendDocumentationPopup-module__relative___IHJHb`,
	"fixed": `SendDocumentationPopup-module__fixed___Beh_T`,
	"visible": `SendDocumentationPopup-module__visible___cwIey`,
	"invisible": `SendDocumentationPopup-module__invisible___o0i2u`,
	"col90": `SendDocumentationPopup-module__col-90___WuNkB`,
	"colAuto": `SendDocumentationPopup-module__col-auto___sfOsD`,
	"medicalTabs": `SendDocumentationPopup-module__medical-tabs___BwmtS`,
	"medicalTableNew": `SendDocumentationPopup-module__medical-table-new___iJp8t`,
	"noPagination": `SendDocumentationPopup-module__no-pagination___HlX7h`,
	"medicalTableEmpty": `SendDocumentationPopup-module__medical-table-empty___gHuF6`,
	"iconBtn": `SendDocumentationPopup-module__icon-btn___dVWgS`,
	"searchIcon": `SendDocumentationPopup-module__search-icon___9FeZl`,
	"disableSelect": `SendDocumentationPopup-module__disable-select___qe7tQ`,
	"breakWord": `SendDocumentationPopup-module__break-word___cIV9a`,
	"popupClearBtn": `SendDocumentationPopup-module__popup-clear-btn___YkhYd`,
	"scrollMB20": `SendDocumentationPopup-module__scroll-m-b-20___fOlIq`,
	"label": `SendDocumentationPopup-module__label___Yu6Mu`,
	"grid": `SendDocumentationPopup-module__grid___jKjZC`,
	"error": `SendDocumentationPopup-module__error___YAoEb`,
	"buttonsContainer": `SendDocumentationPopup-module__buttonsContainer___B_zZN`
};
module.exports = ___CSS_LOADER_EXPORT___;
